import { create } from "zustand";
import { authenticatedAxios, baseURL } from "../../apis";

const useUserlist = create((set, get) => ({
  users: {
    results: [],
    page: 1,
    size: 10,
    total: 0,
    has_next: false,
  },
  admins: {
    results: [],
    page: 1,
    size: 10,
    total: 0,
    has_next: false,
  },
  loaded: false,
  isExporting: false, // State baru untuk loading export
  isSubmitting: false, // State dari fitur createAdmin
  error: null,
  actions: {
    setUsers: (payload) => {
      set(() => ({ users: payload }));
    },
    getUsers: async ({ page, size, search, status, sort_by, order }) => {
      set(() => ({ loaded: false }));
      try {
        const { data } = await authenticatedAxios.get(
          `${baseURL}/api/admin/users`,
          {
            params: {
              page: page ?? 1,
              size: size ?? 5,
              search: search || undefined,
              status: status || undefined,
              sort_by: sort_by || undefined,
              order: order || undefined,
            },
          }
        );
        console.log(data);
        set(() => ({ users: data }));
      } catch (err) {
        console.log(err);
      } finally {
        set(() => ({ loaded: true }));
      }
    },
    getAdmins: async ({ page, size, search, status, sort_by, order }) => {
      set(() => ({ loaded: false }));
      try {
        const { data } = await authenticatedAxios.get(
          `${baseURL}/api/admin/admins`,
          {
            params: {
              page: page ?? 1,
              size: size ?? 10,
              search: search || undefined,
              status: status || undefined,
              sort_by: sort_by || undefined,
              order: order || undefined,
            },
          }
        );
        console.log(data);
        set(() => ({ admins: data }));
      } catch (err) {
        console.log(err);
      } finally {
        set(() => ({ loaded: true }));
      }
    },
    createAdmin: async (adminData) => {
      set({ isSubmitting: true, error: null });
      try {
        await authenticatedAxios.post(
          `${baseURL}/api/admin/admins/create`,
          adminData
        );
        // Sekarang 'get' sudah terdefinisi dan bisa dipanggil
        await get().actions.getAdmins({});
        return true;
      } catch (err) {
        const errorData = err.response?.data;
        set({ error: errorData || { message: "Failed to create admin." } });
        console.error("Failed to create admin:", err);
        return false;
      } finally {
        set({ isSubmitting: false });
      }
    },
    exportUsers: async () => {
      set({ isExporting: true });

      try {
        let jobId = null;
        let fileUrl = null;
        let attempts = 0;
        const maxAttempts = 60;
        let retryInitialCount = 0; // To prevent infinite loops if the backend is truly broken

        // Helper function to get a new Job ID
        const getNewJobId = async () => {
          const initResponse = await authenticatedAxios.get(
            `${baseURL}/api/admin/users/export/background`
          );
          return initResponse.data.job_id;
        };

        // 1. Initial Call
        jobId = await getNewJobId();
        if (!jobId) throw new Error("No Job ID returned");

        // 2. Adaptive Polling Loop
        while (!fileUrl && attempts < maxAttempts) {
          const delay = attempts < 5 ? 2000 : 7500;
          await new Promise((resolve) => setTimeout(resolve, delay));

          try {
            const statusResponse = await authenticatedAxios.get(
              `${baseURL}/api/admin/users/export/background/${jobId}`
            );

            if (statusResponse.data.file_url) {
              fileUrl = statusResponse.data.file_url;
            }
            // If status is just 'queued' or 'processing', the loop continues naturally
          } catch (err) {
            const errorMessage = err.response?.data?.detail || "";

            // CHECK: If ID is missing/deleted on server
            if (
              errorMessage.includes("No AdminExportUsersJob matches") &&
              retryInitialCount < 2
            ) {
              console.warn(
                "Job ID lost on server. Attempting to generate a new one..."
              );

              jobId = await getNewJobId(); // Refresh the ID
              retryInitialCount++; // Track retries so we don't loop forever
              attempts = 0; // Reset attempts for the new ID
              continue; // Jump to start of loop with the new ID
            }

            // If it's a different error, throw it
            throw err;
          }

          attempts++;
        }

        if (!fileUrl) throw new Error("Export timed out.");

        // 3. Download
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", `users_export_${jobId}.xlsx`);
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } catch (err) {
        console.error("Export Error:", err);
        // alert(
        //   err.response?.data?.detail || err.message || "Failed to export data."
        // );
      } finally {
        set({ isExporting: false });
      }
    },
  },
}));

export default useUserlist;
